import { routes } from '@config/routes';
import { createRouteUrl } from '@lib/routing/create-route-url';

export const createDictationStreamUrl = (eventId: string) => {
    const dictationStreamUrl = createRouteUrl(routes.dictationStream, { eventId });
    const site = window.location.origin;

    return site + dictationStreamUrl;
};
